import React from "react";
import { RegisterForm } from "../design-system/components/cadastro/Cadastro";
import api from "../services/api";


export default function Cadastro(){


  async function handleRegister(data){

    try {

      const resposta = await api.post(
        "/auth/cadastro.php",
        data
      );


      console.log(resposta.data);


    } catch(error){

      console.error(error);

    }

  }


  return (

    <div className="
      min-h-screen 
      bg-background 
      flex 
      items-center 
      justify-center
      px-6
    ">

      <RegisterForm 
        onSubmit={handleRegister}
      />

    </div>

  );

}